import { ProcesarDatosApi } from "../api/ApiFetch";

const controlador = "evaluacion";


export const ObtenerEvaluaciones = async () => {
    const url = `${controlador}/ObtenerEvaluaciones`;
    return await ProcesarDatosApi("GET", url);
};


export const ObtenerEvaluacionPorId = async (idEvaluacion) => {
    const url = `${controlador}/ObtenerEvaluacionPorId/${idEvaluacion}`;
    return await ProcesarDatosApi("GET", url);
};

export const CrearEvaluacion = async (data) => {
    const url = `${controlador}/CrearEvaluacion`;
    return await ProcesarDatosApi("POST", url, data);
};


export const GuardarRespuesta = async (data) => {
    const url = `${controlador}/GuardarRespuesta`;
    return await ProcesarDatosApi("POST", url, data);

    
};


export const ObtenerReporteEvaluacion = async (idFormulario, idEvaluado) => {
    const url = `${controlador}/ObtenerReporteEvaluacion/${idFormulario}/${idEvaluado}`;
    return await ProcesarDatosApi("GET", url);
};


export const ObtenerReporteEvaluacionFormulario = async (idFormulario) => {
    const url = `${controlador}/ObtenerReporteEvaluacionFormulario/${idFormulario}`;
    return await ProcesarDatosApi("GET", url);
};